import { render, staticRenderFns } from "./VesselApiForm.vue?vue&type=template&id=1a9d5d28&"
import script from "./VesselApiForm.vue?vue&type=script&lang=js&"
export * from "./VesselApiForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports